import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiUser,FiPackage,FiHash,FiCheck,FiX,FiInfo,FiAlertTriangle,FiImage,FiUpload,FiTrash2,FiMapPin,FiKey,FiLock,FiUserPlus,FiUserMinus,FiRefreshCw,FiHandshake,FiChevronDown,FiEdit,FiDownload}=FiIcons;

const IturriForm=()=> {
  // Inicializar solicitante desde localStorage si existe
  const [formData,setFormData]=useState({
    solicitante: localStorage.getItem('iturriUltimoSolicitante') || '',
    tipoIncidencia: '',
    nombreEmpleado: '',
    nombreCompleto: '',
    numeroEmpleado: '',
    ubicacion: '',
    taquilla: '',
    producto: '',
    tallaAnterior: '',
    tallaNueva: '',
    codigoRotura: '',
    descripcion: '',
    imagenes: []
  });

  const [isSubmitting,setIsSubmitting]=useState(false);
  const [message,setMessage]=useState({type: '',text: ''});
  const [showConfirmModal,setShowConfirmModal]=useState(false);
  const [showSolicitanteModal,setShowSolicitanteModal]=useState(false);

  const solicitantes=[
    {value: 'eduardo-ruescas',label: 'Edu Ruescas',shortName: 'Edu'},
    {value: 'hector-guzowski',label: 'Héctor Guzowski',shortName: 'Héctor'}
  ];

  const tiposIncidencia=[
    {value: 'cambio-talla',label: 'Cambio de talla'},
    {value: 'rotura',label: 'Rotura'},
    {value: 'alta-usuario',label: 'Alta de usuario'},
    {value: 'baja-usuario',label: 'Baja de usuario'},
    {value: 'otra',label: 'Otra incidencia'}
  ];

  const ubicaciones=[
    {value: 'V1',label: 'V1'},
    {value: 'V2',label: 'V2'},
    {value: 'V3',label: 'V3'},
    {value: 'V4',label: 'V4'},
    {value: 'V5',label: 'V5'},
    {value: 'V6',label: 'V6'},
    {value: 'V7',label: 'V7'},
    {value: 'V8',label: 'V8'},
    {value: 'V9',label: 'V9'},
    {value: 'V10',label: 'V10'},
    {value: 'V11',label: 'V11'},
    {value: 'V12',label: 'V12'},
    {value: 'V13',label: 'V13'},
    {value: 'V14',label: 'V14'},
    {value: 'V18',label: 'V18'},
    {value: 'V32',label: 'V32'},
    {value: 'V33',label: 'V33'},
    {value: 'V34',label: 'V34'},
    {value: 'V35',label: 'V35'},
    {value: 'nave-9-retail',label: 'Nave 9 Retail'},
    {value: 'nave-11',label: 'Nave 11'},
    {value: 'cuadras',label: 'Cuadras'}
  ];

  const tallas=[
    {value: 'SP',label: 'SP'},
    {value: 'P',label: 'P'},
    {value: 'M',label: 'M'},
    {value: 'G',label: 'G'},
    {value: 'SG',label: 'SG'},
    {value: '2SG',label: '2SG'},
    {value: '3SG',label: '3SG'}
  ];

  const productos=[
    {value: 'pantalon-acolchado',label: 'Pantalón acolchado'},
    {value: 'chaqueta-acolchada',label: 'Chaqueta acolchada'}
  ];

  // Función para obtener mensaje de saludo personalizado
  const getGreetingMessage=()=> {
    if (!formData.solicitante) return null;
    
    const solicitante=solicitantes.find(s=> s.value===formData.solicitante);
    if (!solicitante) return null;
    
    const currentHour=new Date().getHours();
    let timeGreeting='';
    
    if (currentHour < 12) {
      timeGreeting='Buenos días';
    } else if (currentHour < 18) {
      timeGreeting='Buenas tardes';
    } else {
      timeGreeting='Buenas noches';
    }
    
    return {
      text: `${timeGreeting}, ${solicitante.shortName} 👋`,
      shortName: solicitante.shortName
    };
  };

  // Guardar solicitante en localStorage cuando cambia
  useEffect(()=> {
    if (formData.solicitante) {
      localStorage.setItem('iturriUltimoSolicitante',formData.solicitante);
    }
  },[formData.solicitante]);

  const handleInputChange=(e)=> {
    const {name,value}=e.target;
    
    // Validación especial para el código de rotura (solo números,máximo 10 dígitos)
    if (name==='codigoRotura') {
      const numericValue=value.replace(/\D/g,'').slice(0,10);
      setFormData(prev=> ({...prev,[name]: numericValue}));
      return;
    }
    
    // Validación especial para número de empleado (solo números,máximo 6 dígitos)
    if (name==='numeroEmpleado') {
      const numericValue=value.replace(/\D/g,'').slice(0,6);
      setFormData(prev=> ({...prev,[name]: numericValue}));
      return;
    }
    
    // Manejo especial para solicitante - actualizar formData y localStorage
    if (name==='solicitante') {
      setFormData(prev=> ({...prev,[name]: value}));
      // Guardar inmediatamente en localStorage para persistencia
      if (value) {
        localStorage.setItem('iturriUltimoSolicitante',value);
      } else {
        localStorage.removeItem('iturriUltimoSolicitante');
      }
      return;
    }
    
    setFormData(prev=> ({...prev,[name]: value}));
  };

  // Función para seleccionar solicitante desde el modal
  const handleSolicitanteSelect=(solicitanteValue)=> {
    setFormData(prev=> ({...prev,solicitante: solicitanteValue}));
    localStorage.setItem('iturriUltimoSolicitante',solicitanteValue);
    setShowSolicitanteModal(false);
  };

  const handleImageUpload=(e)=> {
    const files=Array.from(e.target.files);
    
    files.forEach(file=> {
      if (file.size > 5 * 1024 * 1024) {// 5MB límite
        setMessage({type: 'error',text: `La imagen ${file.name} es demasiado grande. Máximo 5MB por imagen.`});
        return;
      }
      
      const reader=new FileReader();
      reader.onload=(event)=> {
        const newImage={
          id: Date.now() + Math.random(),
          name: file.name,
          data: event.target.result,
          size: file.size
        };
        setFormData(prev=> ({...prev,imagenes: [...prev.imagenes,newImage]}));
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage=(imageId)=> {
    setFormData(prev=> ({...prev,imagenes: prev.imagenes.filter(img=> img.id !==imageId)}));
  };

  const saveToLocalStorage=(data)=> {
    const existingData=JSON.parse(localStorage.getItem('iturriSolicitudes') || '[]');
    const newEntry={...data,fecha: new Date().toISOString(),id: Date.now()};
    existingData.push(newEntry);
    localStorage.setItem('iturriSolicitudes',JSON.stringify(existingData));
  };

  // Generar archivo .eml
  const generateEMLFile=(data)=> {
    const tipoIncidenciaLabel=tiposIncidencia.find(t=> t.value===data.tipoIncidencia)?.label || data.tipoIncidencia;
    const solicitanteLabel=solicitantes.find(s=> s.value===data.solicitante)?.label || data.solicitante;
    const productoLabel=data.producto ? (productos.find(p=> p.value===data.producto)?.label || data.producto) : 'N/A';
    const ubicacionLabel=data.ubicacion ? (ubicaciones.find(u=> u.value===data.ubicacion)?.label || data.ubicacion) : 'N/A';

    // Generar timestamp único
    const timestamp=new Date().toISOString().replace(/[:.]/g,'-');
    const fileName=`incidencia-vestuario-${timestamp}.eml`;

    // Generar fecha en formato RFC 2822
    const rfcDate=new Date().toUTCString().replace(/GMT/g,'+0000');

    // Generar boundary único para multipart
    const boundary=`----=_NextPart_${Date.now()}.${Math.random().toString(36).substr(2,9)}`;

    // Construir el cuerpo del email
    const emailBody=`
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    body {font-family: Arial,sans-serif;margin: 0;padding: 20px;background-color: #f5f5f5;}
    .container {max-width: 600px;margin: 0 auto;background-color: white;border-radius: 8px;overflow: hidden;box-shadow: 0 2px 10px rgba(0,0,0,0.1);}
    .header {background-color: #fb2245;color: white;padding: 20px;text-align: center;}
    .content {padding: 20px;}
    .info-table {width: 100%;border-collapse: collapse;margin: 20px 0;}
    .info-table td {padding: 12px;border: 1px solid #ddd;}
    .info-table td:first-child {background-color: #f8f9fa;font-weight: bold;width: 40%;}
    .info-table td:nth-child(even) {background-color: #ffffff;}
    .info-table tr:nth-child(even) td:first-child {background-color: #e9ecef;}
    .highlight {background-color: #fff3cd !important;border-left: 4px solid #ffc107 !important;}
    .user-management {background-color: #e8f5e8;border-left: 4px solid #28a745;padding: 15px;margin: 20px 0;}
    .user-termination {background-color: #ffeaea;border-left: 4px solid #dc3545;padding: 15px;margin: 20px 0;}
    .footer {background-color: #f8f9fa;padding: 15px;text-align: center;font-size: 12px;color: #6c757d;}
    .images-info {background-color: #e3f2fd;border-left: 4px solid #2196f3;padding: 15px;margin: 20px 0;}
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h2>NUEVA INCIDENCIA</h2>
    </div>
    <div class="content">
      <p>Hola equipo.</p>
      <p>Tenemos una nueva incidencia que requiere de vuestra atención:</p>
      <table class="info-table">
        <tr>
          <td>SOLICITANTE</td>
          <td>${solicitanteLabel}</td>
        </tr>
        <tr>
          <td>TIPO DE INCIDENCIA</td>
          <td>${tipoIncidenciaLabel}</td>
        </tr>
        ${data.numeroEmpleado ? `
        <tr>
          <td>NÚMERO DE EMPLEADO</td>
          <td>${data.numeroEmpleado}</td>
        </tr>
        ` : ''}
        ${data.nombreEmpleado ? `
        <tr>
          <td>NOMBRE DEL EMPLEADO</td>
          <td>${data.nombreEmpleado}</td>
        </tr>
        ` : ''}
        ${data.nombreCompleto ? `
        <tr>
          <td>NOMBRE COMPLETO</td>
          <td>${data.nombreCompleto}</td>
        </tr>
        ` : ''}
        ${data.ubicacion ? `
        <tr>
          <td>UBICACIÓN</td>
          <td>${ubicacionLabel}</td>
        </tr>
        ` : ''}
        ${data.taquilla ? `
        <tr>
          <td>NÚMERO DE TAQUILLA</td>
          <td>${data.taquilla}</td>
        </tr>
        ` : ''}
        ${data.producto ? `
        <tr>
          <td>TIPO DE PRENDA</td>
          <td>${productoLabel}</td>
        </tr>
        ` : ''}
        ${data.tallaAnterior ? `
        <tr>
          <td>TALLA ANTERIOR</td>
          <td>${data.tallaAnterior}</td>
        </tr>
        ` : ''}
        ${data.tallaNueva ? `
        <tr>
          <td>TALLA NUEVA</td>
          <td>${data.tallaNueva}</td>
        </tr>
        ` : ''}
        ${data.codigoRotura ? `
        <tr>
          <td>CÓDIGO DE ROTURA</td>
          <td>${data.codigoRotura}</td>
        </tr>
        ` : ''}
        <tr>
          <td>DESCRIPCIÓN</td>
          <td>${data.descripcion || 'Sin descripción adicional'}</td>
        </tr>
        <tr>
          <td>FECHA Y HORA</td>
          <td>${new Date().toLocaleString('es-ES',{day: '2-digit',month: '2-digit',year: 'numeric',hour: '2-digit',minute: '2-digit'})}</td>
        </tr>
      </table>
      ${data.tipoIncidencia==='alta-usuario' ? `
      <div class="user-management">
        <p style="margin: 0;color: #155724;font-weight: bold;">ACCIÓN REQUERIDA - ALTA DE USUARIO:</p>
        <p style="margin: 5px 0 0 0;color: #155724;">Preparar y entregar equipamiento completo para el nuevo empleado.</p>
      </div>
      ` : ''}
      ${data.tipoIncidencia==='baja-usuario' ? `
      <div class="user-termination">
        <p style="margin: 0;color: #721c24;font-weight: bold;">ACCIÓN REQUERIDA - BAJA DE USUARIO:</p>
        <p style="margin: 5px 0 0 0;color: #721c24;">Proceder con la recuperación de todo el equipamiento asignado al empleado.</p>
      </div>
      ` : ''}
      ${data.imagenes.length > 0 ? `
      <div class="images-info">
        <p style="margin: 0;color: #1976d2;font-weight: bold;">Esta incidencia incluye ${data.imagenes.length} imagen(es) adjunta(s)</p>
        <p style="margin: 5px 0 0 0;color: #666;font-size: 14px;">Las imágenes están almacenadas en el sistema local del solicitante.</p>
        <p style="margin: 5px 0 0 0;color: #666;font-size: 14px;">Para ver las imágenes,contactar directamente con el solicitante.</p>
      </div>
      ` : ''}
      ${data.tipoIncidencia !=='alta-usuario' && data.tipoIncidencia !=='baja-usuario' ? `
      <div style="background-color: #d4edda;border-left: 4px solid #28a745;padding: 15px;margin: 20px 0;">
        <p style="margin: 0;color: #155724;font-weight: bold;">ACCIÓN REQUERIDA:</p>
        <p style="margin: 5px 0 0 0;color: #155724;">Por favor,procesar esta incidencia según el protocolo establecido.</p>
      </div>
      ` : ''}
    </div>
    <div class="footer">
      <p><strong>Sistema Automático de Incidencias - Iturri</strong></p>
      <p>Este correo fue generado automáticamente el ${new Date().toLocaleDateString('es-ES')}</p>
    </div>
  </div>
</body>
</html>`;

    // Construir el contenido del archivo .eml con CC
    const emlContent=`From: ${solicitanteLabel} <sistema@iturri.com>
To: amangeles@iturri.com
Cc: rsgarcia@iturri.com, afcuevas@iturri.com
Subject: [MEDINA] (${tipoIncidenciaLabel})
Date: ${rfcDate}
MIME-Version: 1.0
Content-Type: multipart/alternative; boundary="${boundary}"

--${boundary}
Content-Type: text/plain; charset=utf-8
Content-Transfer-Encoding: 8bit

NUEVA INCIDENCIA - Iturri

Solicitante: ${solicitanteLabel}
Tipo: ${tipoIncidenciaLabel}
${data.numeroEmpleado ? `Número de empleado: ${data.numeroEmpleado}` : ''}
${data.nombreEmpleado ? `Nombre del empleado: ${data.nombreEmpleado}` : ''}
${data.nombreCompleto ? `Nombre completo: ${data.nombreCompleto}` : ''}
${data.ubicacion ? `Ubicación: ${ubicacionLabel}` : ''}
${data.taquilla ? `Taquilla: ${data.taquilla}` : ''}
${data.producto ? `Producto: ${productoLabel}` : ''}
${data.tallaAnterior ? `Talla anterior: ${data.tallaAnterior}` : ''}
${data.tallaNueva ? `Talla nueva: ${data.tallaNueva}` : ''}
${data.codigoRotura ? `Código de rotura: ${data.codigoRotura}` : ''}
${data.descripcion ? `Descripción: ${data.descripcion}` : ''}
Fecha: ${new Date().toLocaleString('es-ES')}

--${boundary}
Content-Type: text/html; charset=utf-8
Content-Transfer-Encoding: 8bit

${emailBody}

--${boundary}--
`;

    return { fileName, emlContent };
  };

  // Descargar y abrir archivo .eml
  const downloadAndOpenEML=(emlData)=> {
    try {
      // Crear Blob con el contenido
      const blob=new Blob([emlData.emlContent],{type: 'message/rfc822'});
      
      // Crear URL temporal
      const url=URL.createObjectURL(blob);
      
      // Crear enlace temporal para descargar
      const link=document.createElement('a');
      link.href=url;
      link.download=emlData.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Limpiar URL temporal
      setTimeout(()=> URL.revokeObjectURL(url),100);
      
      return true;
    } catch (error) {
      console.error('Error al generar archivo .eml:',error);
      return false;
    }
  };

  const validateForm=()=> {
    // Validaciones básicas
    if (!formData.solicitante || !formData.tipoIncidencia) {
      setMessage({type: 'error',text: 'Por favor,completa los campos obligatorios.'});
      return false;
    }

    // Validaciones comunes para todos los tipos de incidencia
    if (!formData.nombreEmpleado || !formData.numeroEmpleado || !formData.ubicacion) {
      setMessage({type: 'error',text: 'Por favor,completa todos los campos obligatorios: Nombre del empleado, número de empleado y ubicación.'});
      return false;
    }

    // Validación de taquilla: obligatoria excepto para Cuadras
    if (formData.ubicacion !=='cuadras' && !formData.taquilla) {
      setMessage({type: 'error',text: 'El número de taquilla es obligatorio para esta ubicación.'});
      return false;
    }

    // Validaciones para incidencias de prendas (cambio de talla y rotura)
    if (shouldShowProductFields) {
      if (!formData.producto || !formData.tallaAnterior || !formData.tallaNueva) {
        setMessage({type: 'error',text: 'Por favor,completa todos los campos de prenda y tallas.'});
        return false;
      }

      // Validación específica para rotura: código de 10 dígitos obligatorio
      if (formData.tipoIncidencia==='rotura') {
        if (!formData.codigoRotura || formData.codigoRotura.length !==10) {
          setMessage({type: 'error',text: 'El código de rotura debe tener exactamente 10 dígitos.'});
          return false;
        }
      }
    }

    // Validación para "Otra incidencia"
    if (formData.tipoIncidencia==='otra' && !formData.descripcion) {
      setMessage({type: 'error',text: 'La descripción es obligatoria para "Otra incidencia".'});
      return false;
    }

    return true;
  };

  const handleSubmit=(e)=> {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setShowConfirmModal(true);
  };

  const confirmAndSend=async ()=> {
    setShowConfirmModal(false);
    setIsSubmitting(true);

    try {
      // Guardar en localStorage
      saveToLocalStorage(formData);

      // Generar archivo .eml
      const emlData=generateEMLFile(formData);

      // Descargar y abrir el archivo
      const success=downloadAndOpenEML(emlData);

      if (success) {
        setMessage({type: 'success',text: '✅ Incidencia registrada. Se ha generado el correo electrónico para enviar.'});

        // Resetear formulario (mantener solicitante)
        const currentSolicitante=formData.solicitante;
        setFormData({
          solicitante: currentSolicitante,
          tipoIncidencia: '',
          nombreEmpleado: '',
          nombreCompleto: '',
          numeroEmpleado: '',
          ubicacion: '',
          taquilla: '',
          producto: '',
          tallaAnterior: '',
          tallaNueva: '',
          codigoRotura: '',
          descripcion: '',
          imagenes: []
        });
      } else {
        setMessage({type: 'error',text: 'Error al generar el archivo de correo. Por favor,inténtalo de nuevo.'});
      }
    } catch (error) {
      console.error('Error:',error);
      setMessage({type: 'error',text: 'Error al procesar la incidencia. Por favor,inténtalo de nuevo.'});
    }

    setIsSubmitting(false);
    setTimeout(()=> setMessage({type: '',text: ''}),5000);
  };

  // Determinar qué campos mostrar según el tipo de incidencia
  const shouldShowProductFields=formData.tipoIncidencia && (
    formData.tipoIncidencia==='cambio-talla' || 
    formData.tipoIncidencia==='rotura'
  );

  const shouldShowEmployeeFields=formData.tipoIncidencia && (
    formData.tipoIncidencia==='alta-usuario' || 
    formData.tipoIncidencia==='baja-usuario'
  );

  // Determinar si la taquilla es obligatoria
  const isTaquillaRequired=formData.ubicacion && formData.ubicacion !=='cuadras';

  // Obtener mensaje de saludo
  const greetingMessage=getGreetingMessage();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Cabecera fija */}
      <motion.header 
        className="fixed top-0 left-0 right-0 z-50 bg-[#FF2047] shadow-lg"
        initial={{y: -70}}
        animate={{y: 0}}
        transition={{duration: 0.5,ease: "easeOut"}}
      >
        <div className="h-[70px] px-6 flex items-center justify-between">
          {/* Logo de Iturri en blanco - movido a la izquierda */}
          <div className="flex items-center">
            <img 
              src="https://assets.brandbay.io/brands/1736547941865x394131539339247600/assets/Y7TrUoiturri%20horizontal%20bl.svg"
              alt="Logo de Iturri"
              className="h-10 w-auto object-contain"
            />
          </div>
          
          {/* Título justificado a la derecha */}
          <h1 className="text-white text-xl font-bold tracking-tight text-right">
            Incidencias
          </h1>
        </div>
      </motion.header>

      {/* Contenido principal con margen superior para la cabecera */}
      <div className="pt-[70px] flex-1 bg-gradient-to-br from-gray-50 to-gray-100">
        {/* Saludo personalizado integrado en el contenido principal */}
        <AnimatePresence>
          {greetingMessage && (
            <motion.div 
              initial={{opacity: 0,y: -10}}
              animate={{opacity: 1,y: 0}}
              exit={{opacity: 0,y: -10}}
              transition={{duration: 0.3}}
              className="max-w-2xl mx-auto px-4 py-6"
            >
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 px-4 py-3 flex items-center justify-between">
                <h2 className="text-lg md:text-xl font-semibold text-gray-800 truncate flex-1 mr-2">
                  {greetingMessage.text}
                </h2>
                <button
                  onClick={()=> setShowSolicitanteModal(true)}
                  className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200 flex-shrink-0"
                  aria-label="Cambiar solicitante"
                >
                  <SafeIcon icon={FiEdit} className="w-4 h-4" />
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="max-w-2xl mx-auto px-4 pb-8">
          {/* Formulario */}
          <motion.div 
            className="bg-white rounded-2xl shadow-xl p-8" 
            initial={{opacity: 0,y: 20}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.6,delay: 0.2}}
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Solicitante - ocultar si ya está seleccionado */}
              {!greetingMessage && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <SafeIcon icon={FiUser} className="inline w-4 h-4 mr-2" />
                    Solicitante <span className="text-red-500">*</span>
                  </label>
                  <div className="flex space-x-2">
                    <select 
                      name="solicitante" 
                      value={formData.solicitante} 
                      onChange={handleInputChange} 
                      required
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                      aria-label="Solicitante de la incidencia"
                    >
                      <option value="">Selecciona el solicitante</option>
                      {solicitantes.map(solicitante=> (
                        <option key={solicitante.value} value={solicitante.value}>
                          {solicitante.label}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      onClick={()=> setShowSolicitanteModal(true)}
                      className="px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 focus:ring-2 focus:ring-gray-300 transition-all duration-200"
                      aria-label="Seleccionar solicitante con modal"
                    >
                      <SafeIcon icon={FiChevronDown} className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              )}

              {/* Tipo de incidencia */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <SafeIcon icon={FiAlertTriangle} className="inline w-4 h-4 mr-2" />
                  Tipo de incidencia <span className="text-red-500">*</span>
                </label>
                <select 
                  name="tipoIncidencia" 
                  value={formData.tipoIncidencia} 
                  onChange={handleInputChange} 
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                  aria-label="Tipo de incidencia"
                >
                  <option value="">Selecciona el tipo de incidencia</option>
                  {tiposIncidencia.map(tipo=> (
                    <option key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Campos comunes para todos los tipos de incidencia */}
              <AnimatePresence>
                {formData.tipoIncidencia && (
                  <motion.div 
                    initial={{opacity: 0,height: 0}} 
                    animate={{opacity: 1,height: 'auto'}} 
                    exit={{opacity: 0,height: 0}} 
                    transition={{duration: 0.3}} 
                    className="space-y-6"
                  >
                    {/* Número de empleado */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiHash} className="inline w-4 h-4 mr-2" />
                        Número de empleado <span className="text-red-500">*</span>
                      </label>
                      <input 
                        type="text" 
                        name="numeroEmpleado" 
                        value={formData.numeroEmpleado} 
                        onChange={handleInputChange} 
                        required
                        maxLength="6"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        placeholder="123456"
                        aria-label="Número de identificación del empleado"
                      />
                    </div>

                    {/* Nombre del empleado (campo común) */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiUser} className="inline w-4 h-4 mr-2" />
                        Nombre del empleado <span className="text-red-500">*</span>
                      </label>
                      <input 
                        type="text" 
                        name="nombreEmpleado" 
                        value={formData.nombreEmpleado} 
                        onChange={handleInputChange} 
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        placeholder="Introduce el nombre del empleado"
                        aria-label="Nombre del empleado"
                      />
                    </div>

                    {/* Ubicación */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiMapPin} className="inline w-4 h-4 mr-2" />
                        Ubicación <span className="text-red-500">*</span>
                      </label>
                      <select 
                        name="ubicacion" 
                        value={formData.ubicacion} 
                        onChange={handleInputChange} 
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        aria-label="Ubicación del vestuario"
                      >
                        <option value="">Selecciona la ubicación</option>
                        {ubicaciones.map(ubicacion=> (
                          <option key={ubicacion.value} value={ubicacion.value}>
                            {ubicacion.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Taquilla */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiKey} className="inline w-4 h-4 mr-2" />
                        Número de taquilla {isTaquillaRequired && <span className="text-red-500">*</span>}
                        {!isTaquillaRequired && formData.ubicacion && (
                          <span className="text-gray-500 text-xs ml-2">(Opcional para Cuadras)</span>
                        )}
                      </label>
                      <input 
                        type="text" 
                        name="taquilla" 
                        value={formData.taquilla} 
                        onChange={handleInputChange} 
                        required={isTaquillaRequired}
                        disabled={formData.ubicacion==='cuadras'}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200 ${
                          formData.ubicacion==='cuadras' ? 'bg-gray-50 text-gray-500' : ''
                        }`}
                        placeholder={formData.ubicacion==='cuadras' ? 'No aplica para Cuadras' : 'Introduce el número de taquilla'}
                        aria-label="Número de taquilla del empleado"
                      />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Campos para incidencias de prendas (Cambio de talla y Rotura) */}
              <AnimatePresence>
                {shouldShowProductFields && (
                  <motion.div 
                    initial={{opacity: 0,height: 0}} 
                    animate={{opacity: 1,height: 'auto'}} 
                    exit={{opacity: 0,height: 0}} 
                    transition={{duration: 0.3}} 
                    className="space-y-6"
                  >
                    {/* Nombre completo del empleado (solo para prendas) */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiUser} className="inline w-4 h-4 mr-2" />
                        Nombre completo del empleado <span className="text-red-500">*</span>
                      </label>
                      <input 
                        type="text" 
                        name="nombreCompleto" 
                        value={formData.nombreCompleto} 
                        onChange={handleInputChange} 
                        required={shouldShowProductFields}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        placeholder="Introduce el nombre completo del empleado"
                        aria-label="Nombre completo del empleado"
                      />
                    </div>

                    {/* Tipo de prenda */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiPackage} className="inline w-4 h-4 mr-2" />
                        Tipo de prenda <span className="text-red-500">*</span>
                      </label>
                      <select 
                        name="producto" 
                        value={formData.producto} 
                        onChange={handleInputChange} 
                        required={shouldShowProductFields}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        aria-label="Tipo de prenda afectada"
                      >
                        <option value="">Selecciona un tipo de prenda</option>
                        {productos.map(producto=> (
                          <option key={producto.value} value={producto.value}>
                            {producto.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Talla anterior */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiRefreshCw} className="inline w-4 h-4 mr-2" />
                        Talla anterior <span className="text-red-500">*</span>
                      </label>
                      <select 
                        name="tallaAnterior" 
                        value={formData.tallaAnterior} 
                        onChange={handleInputChange} 
                        required={shouldShowProductFields}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        aria-label="Talla anterior de la prenda"
                      >
                        <option value="">Selecciona la talla anterior</option>
                        {tallas.map(talla=> (
                          <option key={talla.value} value={talla.value}>
                            {talla.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Talla nueva */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <SafeIcon icon={FiRefreshCw} className="inline w-4 h-4 mr-2" />
                        Talla nueva <span className="text-red-500">*</span>
                      </label>
                      <select 
                        name="tallaNueva" 
                        value={formData.tallaNueva} 
                        onChange={handleInputChange} 
                        required={shouldShowProductFields}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                        aria-label="Talla nueva de la prenda"
                      >
                        <option value="">Selecciona la talla nueva</option>
                        {tallas.map(talla=> (
                          <option key={talla.value} value={talla.value}>
                            {talla.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Código de rotura (solo para tipo "Rotura") */}
                    <AnimatePresence>
                      {formData.tipoIncidencia==='rotura' && (
                        <motion.div 
                          initial={{opacity: 0,height: 0}} 
                          animate={{opacity: 1,height: 'auto'}} 
                          exit={{opacity: 0,height: 0}} 
                          transition={{duration: 0.3}}
                        >
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              <SafeIcon icon={FiHash} className="inline w-4 h-4 mr-2" />
                              Código de rotura <span className="text-red-500">*</span>
                              <span className="text-gray-500 text-xs ml-2">(10 dígitos numéricos)</span>
                            </label>
                            <input 
                              type="text" 
                              name="codigoRotura" 
                              value={formData.codigoRotura} 
                              onChange={handleInputChange} 
                              required={formData.tipoIncidencia==='rotura'}
                              maxLength="10"
                              pattern="[0-9]{10}"
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200"
                              placeholder="1234567890"
                              aria-label="Código de rotura de 10 dígitos"
                            />
                            {formData.codigoRotura && formData.codigoRotura.length < 10 && (
                              <p className="mt-1 text-sm text-orange-600">⚠️ Faltan {10 - formData.codigoRotura.length} dígitos</p>
                            )}
                            {formData.codigoRotura && formData.codigoRotura.length===10 && (
                              <p className="mt-1 text-sm text-green-600">✅ Código completo</p>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>

                    {/* Mensaje informativo según tipo */}
                    <div className={`p-4 rounded-lg border ${
                      formData.tipoIncidencia==='cambio-talla' 
                        ? 'bg-blue-50 border-blue-200 text-blue-800' 
                        : 'bg-orange-50 border-orange-200 text-orange-800'
                    }`}>
                      <div className="flex items-center">
                        <SafeIcon 
                          icon={formData.tipoIncidencia==='cambio-talla' ? FiRefreshCw : FiAlertTriangle} 
                          className="w-5 h-5 mr-2" 
                        />
                        <div>
                          <p className="font-semibold">
                            {formData.tipoIncidencia==='cambio-talla' ? '🔄 Cambio de Talla' : '🔧 Rotura de Prenda'}
                          </p>
                          <p className="text-sm mt-1">
                            {formData.tipoIncidencia==='cambio-talla' 
                              ? 'Se procesará el cambio de talla según disponibilidad.' 
                              : 'Se gestionará la reposición de la prenda afectada.'
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Campos para gestión de usuarios (alta/baja) */}
              <AnimatePresence>
                {shouldShowEmployeeFields && (
                  <motion.div 
                    initial={{opacity: 0,height: 0}} 
                    animate={{opacity: 1,height: 'auto'}} 
                    exit={{opacity: 0,height: 0}} 
                    transition={{duration: 0.3}} 
                    className="space-y-6"
                  >
                    {/* Mensaje informativo según tipo */}
                    <div className={`p-4 rounded-lg border ${
                      formData.tipoIncidencia==='alta-usuario' 
                        ? 'bg-green-50 border-green-200 text-green-800' 
                        : 'bg-red-50 border-red-200 text-red-800'
                    }`}>
                      <div className="flex items-center">
                        <SafeIcon 
                          icon={formData.tipoIncidencia==='alta-usuario' ? FiUserPlus : FiUserMinus} 
                          className="w-5 h-5 mr-2" 
                        />
                        <div>
                          <p className="font-semibold">
                            {formData.tipoIncidencia==='alta-usuario' ? '👕 Alta de Usuario' : '🚪 Baja de Usuario'}
                          </p>
                          <p className="text-sm mt-1">
                            {formData.tipoIncidencia==='alta-usuario' 
                              ? 'Se preparará equipamiento completo para el nuevo empleado.' 
                              : 'Se procederá a recuperar todo el equipamiento asignado.'
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Descripción adicional */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <SafeIcon icon={FiInfo} className="inline w-4 h-4 mr-2" />
                  Descripción adicional {formData.tipoIncidencia==='otra' && <span className="text-red-500">*</span>}
                </label>
                <textarea 
                  name="descripcion" 
                  value={formData.descripcion} 
                  onChange={handleInputChange} 
                  required={formData.tipoIncidencia==='otra'}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#fb2245] focus:border-transparent transition-all duration-200 resize-none"
                  placeholder={
                    formData.tipoIncidencia==='alta-usuario' 
                      ? "Información adicional sobre el alta (opcional)..." 
                      : formData.tipoIncidencia==='baja-usuario' 
                        ? "Información adicional sobre la baja (opcional)..." 
                        : formData.tipoIncidencia==='otra' 
                          ? "Describe detalladamente la incidencia..." 
                          : "Información adicional (opcional)..."
                  }
                  aria-label="Descripción detallada de la incidencia"
                />
              </div>

              {/* Subida de imágenes */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <SafeIcon icon={FiImage} className="inline w-4 h-4 mr-2" />
                  Imágenes (opcional)
                </label>
                <div className="space-y-4">
                  <div className="flex items-center justify-center w-full">
                    <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors duration-200">
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <SafeIcon icon={FiUpload} className="w-8 h-8 mb-2 text-gray-400" />
                        <p className="mb-2 text-sm text-gray-500">
                          <span className="font-semibold">Haz clic para subir</span> o arrastra las imágenes
                        </p>
                        <p className="text-xs text-gray-500">PNG,JPG o JPEG (Máx. 5MB por imagen)</p>
                      </div>
                      <input 
                        type="file" 
                        className="hidden" 
                        accept="image/*" 
                        multiple 
                        onChange={handleImageUpload}
                        aria-label="Subir imágenes de la incidencia"
                      />
                    </label>
                  </div>

                  {/* Previsualización de imágenes */}
                  {formData.imagenes.length > 0 && (
                    <div className="grid grid-cols-2 gap-4">
                      {formData.imagenes.map((imagen)=> (
                        <motion.div 
                          key={imagen.id} 
                          initial={{opacity: 0,scale: 0.8}} 
                          animate={{opacity: 1,scale: 1}} 
                          className="relative group"
                        >
                          <img 
                            src={imagen.data} 
                            alt={imagen.name} 
                            className="w-full h-24 object-cover rounded-lg border border-gray-200" 
                          />
                          <button 
                            type="button" 
                            onClick={()=> removeImage(imagen.id)} 
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
                            aria-label={`Eliminar imagen ${imagen.name}`}
                          >
                            <SafeIcon icon={FiTrash2} className="w-3 h-3" />
                          </button>
                          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 rounded-b-lg truncate">
                            {imagen.name}
                          </div>
                        </motion.div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Botón de envío */}
              <motion.button 
                type="submit" 
                disabled={isSubmitting || !formData.tipoIncidencia}
                className="w-full bg-[#fb2245] text-white py-4 px-6 rounded-lg font-semibold text-lg hover:bg-red-600 focus:ring-4 focus:ring-red-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
                aria-label="Enviar formulario de incidencia"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                    Procesando...
                  </span>
                ) : (
                  <span className="flex items-center justify-center">
                    <SafeIcon icon={FiDownload} className="w-5 h-5 mr-2" />
                    Generar correo electrónico
                  </span>
                )}
              </motion.button>
            </form>

            {/* Mensaje de estado */}
            {message.text && (
              <motion.div 
                initial={{opacity: 0,y: 10}} 
                animate={{opacity: 1,y: 0}} 
                className={`mt-6 p-4 rounded-lg flex items-center ${
                  message.type==='success' 
                    ? 'bg-green-50 text-green-800 border border-green-200' 
                    : message.type==='warning' 
                      ? 'bg-yellow-50 text-yellow-800 border border-yellow-200' 
                      : message.type==='info' 
                        ? 'bg-blue-50 text-blue-800 border border-blue-200' 
                        : 'bg-red-50 text-red-800 border border-red-200'
                }`}
                role="alert"
                aria-live="polite"
              >
                <SafeIcon 
                  icon={message.type==='error' ? FiX : message.type==='info' ? FiInfo : FiCheck} 
                  className="w-5 h-5 mr-2" 
                />
                {message.text}
              </motion.div>
            )}
          </motion.div>
        </div>
      </div>

      {/* Modal de selección de solicitante */}
      <AnimatePresence>
        {showSolicitanteModal && (
          <motion.div 
            initial={{opacity: 0}} 
            animate={{opacity: 1}} 
            exit={{opacity: 0}} 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" 
            onClick={()=> setShowSolicitanteModal(false)}
          >
            <motion.div 
              initial={{scale: 0.9,opacity: 0}} 
              animate={{scale: 1,opacity: 1}} 
              exit={{scale: 0.9,opacity: 0}} 
              transition={{type: "spring",damping: 20,stiffness: 300}} 
              className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold text-gray-900">Seleccionar Solicitante</h3>
                <button
                  onClick={()=> setShowSolicitanteModal(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                  aria-label="Cerrar modal"
                >
                  <SafeIcon icon={FiX} className="w-5 h-5" />
                </button>
              </div>
              
              <div className="space-y-2">
                {solicitantes.map((solicitante)=> (
                  <button
                    key={solicitante.value}
                    onClick={()=> handleSolicitanteSelect(solicitante.value)}
                    className={`w-full text-left px-4 py-3 rounded-lg border transition-all duration-200 ${
                      formData.solicitante===solicitante.value
                        ? 'bg-[#fb2245] text-white border-[#fb2245]'
                        : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300'
                    }`}
                  >
                    <div className="flex items-center">
                      <SafeIcon icon={FiUser} className="w-4 h-4 mr-3" />
                      <span className="font-medium">{solicitante.label}</span>
                      {formData.solicitante===solicitante.value && (
                        <SafeIcon icon={FiCheck} className="w-4 h-4 ml-auto" />
                      )}
                    </div>
                  </button>
                ))}
              </div>
              
              <div className="mt-4 pt-4 border-t border-gray-200">
                <button
                  onClick={()=> setShowSolicitanteModal(false)}
                  className="w-full px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors duration-200"
                >
                  Cancelar
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal de confirmación */}
      <AnimatePresence>
        {showConfirmModal && (
          <motion.div 
            initial={{opacity: 0}} 
            animate={{opacity: 1}} 
            exit={{opacity: 0}} 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" 
            onClick={()=> setShowConfirmModal(false)}
          >
            <motion.div 
              initial={{scale: 0.9,opacity: 0}} 
              animate={{scale: 1,opacity: 1}} 
              exit={{scale: 0.9,opacity: 0}} 
              transition={{type: "spring",damping: 20,stiffness: 300}} 
              className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-4">
                  <SafeIcon icon={FiDownload} className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">¿Generar correo electrónico?</h3>
                <p className="text-gray-600 mb-6">
                  Se generará un archivo de correo electrónico (.eml) que se descargará automáticamente. 
                  Al hacer doble clic en el archivo, se abrirá con Outlook para enviar la incidencia.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3 text-left">
                    <p className="text-sm font-medium text-gray-700">📧 Destinatario:</p>
                    <p className="text-sm text-gray-900">amangeles@iturri.com</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3 text-left">
                    <p className="text-sm font-medium text-gray-700">👥 Con copia (CC):</p>
                    <p className="text-sm text-gray-900">rsgarcia@iturri.com, afcuevas@iturri.com</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3 text-left">
                    <p className="text-sm font-medium text-gray-700">👤 Solicitante:</p>
                    <p className="text-sm text-gray-900">
                      {solicitantes.find(s=> s.value===formData.solicitante)?.label || formData.solicitante}
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3 text-left">
                    <p className="text-sm font-medium text-gray-700">🎯 Tipo:</p>
                    <p className="text-sm text-gray-900">
                      {tiposIncidencia.find(t=> t.value===formData.tipoIncidencia)?.label || formData.tipoIncidencia}
                    </p>
                  </div>
                  {formData.numeroEmpleado && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">🆔 Nº Empleado:</p>
                      <p className="text-sm text-gray-900">{formData.numeroEmpleado}</p>
                    </div>
                  )}
                  {formData.nombreEmpleado && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">👤 Nombre del empleado:</p>
                      <p className="text-sm text-gray-900">{formData.nombreEmpleado}</p>
                    </div>
                  )}
                  {formData.nombreCompleto && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">👥 Nombre completo:</p>
                      <p className="text-sm text-gray-900">{formData.nombreCompleto}</p>
                    </div>
                  )}
                  {formData.ubicacion && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">📍 Ubicación:</p>
                      <p className="text-sm text-gray-900">
                        {ubicaciones.find(u=> u.value===formData.ubicacion)?.label || formData.ubicacion}
                      </p>
                    </div>
                  )}
                  {formData.taquilla && formData.ubicacion !=='cuadras' && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">🏢 Nº Taquilla:</p>
                      <p className="text-sm text-gray-900">{formData.taquilla}</p>
                    </div>
                  )}
                  {formData.tallaAnterior && formData.tallaNueva && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">📏 Tallas:</p>
                      <p className="text-sm text-gray-900">{formData.tallaAnterior} → {formData.tallaNueva}</p>
                    </div>
                  )}
                  {formData.codigoRotura && (
                    <div className="bg-gray-50 rounded-lg p-3 text-left">
                      <p className="text-sm font-medium text-gray-700">🔢 Código de rotura:</p>
                      <p className="text-sm text-gray-900">{formData.codigoRotura}</p>
                    </div>
                  )}
                </div>
                <div className="flex space-x-3">
                  <button 
                    onClick={()=> setShowConfirmModal(false)} 
                    className="flex-1 px-4 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors duration-200"
                  >
                    Cancelar
                  </button>
                  <button 
                    onClick={confirmAndSend} 
                    className="flex-1 px-4 py-3 bg-[#fb2245] text-white rounded-lg font-medium hover:bg-red-600 transition-colors duration-200"
                  >
                    Generar correo
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default IturriForm;